import { render, staticRenderFns } from "./preformAction.vue?vue&type=template&id=96d72af2&scoped=true"
var script = {}
import style0 from "./preformAction.vue?vue&type=style&index=0&id=96d72af2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d72af2",
  null
  
)

export default component.exports